<template>
  <class-detail-section class="teacher-section-info" title="Profile Information">
    <template #actions>
      <button
        v-if="teacherProfile.can_edit"
        class="teacher-section-info__edit-button"
        @click="editSkill"
        data-test-id="edit-button"
      >
        <span class="teacher-section-info__edit-icon">
          <font-awesome-icon :icon="['fas', 'edit']" />
        </span>
      </button>
    </template>

    <div class="teacher-profile">
      <div class="teacher-section-info__split-col">
        <div class="teacher-section-info__avatar">
          <img :src="teacherProfile.profile_image_url" data-test-id="profile-image" />
        </div>
        <h4>Upload</h4>
        <div class="teacher-section-info__buttons">
          <voxy-button size="xs" view="light" @click="editPhoto" data-test-id="edit-photo-button"> Photo </voxy-button>
          <voxy-button size="xs" view="light" @click="editVideo" data-test-id="edit-video-button"> Video </voxy-button>
        </div>
      </div>

      <div class="teacher-section-info__split-col">
        <h2 data-test-id="teacher-name">{{ activeSnippet }}{{ teacherProfile.name }}</h2>
        <h4 data-test-id="teacher-email">{{ teacherProfile.email }}</h4>
        <div class="teacher-section-info__data-item">
          <span class="teacher-section-info__label">Years of experience</span>
          <div class="teacher-section-info__value" data-test-id="experience-years">
            {{ teacherProfile.experience_years }}
          </div>
        </div>
        <div class="teacher-section-info__data-item">
          <span class="teacher-section-info__label">Teaching language</span>
          <div class="teacher-section-info__data-list" data-test-id="teaching-languages">
            <span v-for="language in activeTeachingLanguages" :key="language.name"> {{ language.name }}, </span>
          </div>
        </div>
      </div>

      <div v-if="restrictedSectionVisible" class="teacher-section-info__split-col">
        <div class="teacher-section-info__dark">
          <h4>For Internal Admin Use</h4>
          <div class="teacher-section-info__data-item">
            <span class="teacher-section-info__label">Location Info</span>
            <div class="teacher-section-info__value" data-test-id="bio-location">
              {{ teacherProfile.bio_location }}
            </div>
          </div>
          <div class="teacher-section-info__data-item">
            <span class="teacher-section-info__label">Hourly cost in dollars</span>
            <div class="teacher-section-info__value" data-test-id="hourly-cost-in-dollars">
              {{ teacherProfile.hourly_cost_in_dollars }}
            </div>
          </div>
          <div class="teacher-section-info__data-item">
            <span class="teacher-section-info__label">Teacher Accent</span>
            <div class="teacher-section-info__value" data-test-id="accent">
              {{ teacherProfile.accent }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </class-detail-section>
</template>

<script>
import { VoxyButton } from '@voxy-team/vue-voxy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ClassDetailSection from '@/views/classes/components/ClassDetailSection';
import ModalTeacherPrimaryInfo from './forms/ModalTeacherPrimaryInfo';
import ModalTeacherMedia from './forms/ModalTeacherMedia';
import constants from './forms/constants';

export default {
  name: 'TeacherProfileInfo',

  components: {
    VoxyButton,
    ClassDetailSection,
    FontAwesomeIcon,
  },

  props: {
    teacherProfile: {
      type: Object,
      required: true,
    },
    restrictedSectionVisible: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    activeTeachingLanguages() {
      return this.teacherProfile.teaching_languages.filter(language => {
        return language.active;
      });
    },
    activeSnippet() {
      return this.teacherProfile.active ? '' : '[DEACTIVATED] ';
    },
  },

  methods: {
    openMediaModal(mediaType) {
      this.$modal.show(ModalTeacherMedia, ...constants.modalConfig(this, { mediaType }));
    },
    editSkill() {
      this.$modal.show(
        ModalTeacherPrimaryInfo,
        ...constants.modalConfig(this, {
          restrictedSectionVisible: this.restrictedSectionVisible,
        }),
      );
    },
    editVideo() {
      this.openMediaModal('profile_video');
    },
    editPhoto() {
      this.openMediaModal('profile_image');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';
@import '~styles/components/teacher-management-sections';
</style>
